import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { FieldTypeConfig } from "@ngx-formly/core";
import { FieldType } from "@ngx-formly/material/form-field";
import { objectHasProperty } from "@vp/shared/utilities";
import * as linkify from "linkifyjs";

@Component({
  selector: "lib-formly-json-schema-form-input",
  standalone: false,
  templateUrl: "./form-input.component.html",
  styleUrls: ["./form-input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputComponent extends FieldType<FieldTypeConfig> implements OnInit {
  inputErrorMatcher = new InputErrorMatcher();
  url: string | undefined;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.extractURL();
  }

  onPaste(event: ClipboardEvent) {
    if (this.props?.attributes?.onpaste === "return false;") {
      event.preventDefault();
      this.formControl.setErrors({ pasteNotAllowed: true });
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
    }
  }

  onFocusOut(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    //only trigger if user left input as whitespace only
    if (target.value != "" && !target.value.trim()) {
      this.formControl.setErrors({ whitespace: true });
    }
  }

  extractURL() {
    if (this.field.model && this.field.key && objectHasProperty(this.field.model, this.field.key)) {
      const theValue = this.field.model[this.field.key as string];
      if (typeof theValue === "string") {
        const isUrl = linkify.find(theValue);
        if (isUrl && isUrl.length > 0 && isUrl[0].type === "url") {
          this.url = isUrl[0].href;
        }
      }
    }
  }
}

export class InputErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null): boolean {
    return !!(control?.invalid && (control?.dirty || control?.touched));
  }
}
